import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './OperationsWindow.styles';

const OperationsWindow = ({ targetKeys, onChange, dataSource }) => {
  const isChecked = (selectedKeys, eventKey) => selectedKeys.indexOf(eventKey) !== -1;

  const transferDataSource = [];
  function flatten(list = []) {
    list.forEach((item) => {
      transferDataSource.push(item);
      flatten(item.children);
    });
  }
  flatten(dataSource);

  return (
    <Styled.TablesTransfer
      targetKeys={targetKeys}
      onChange={onChange}
      dataSource={transferDataSource}
      render={(item) => {
        const label = `${item.title}( ${item.key} )`;
        return label;
      }}
      showSelectAll={false}
    >
      {
        // eslint-disable-next-line
        ({ direction, onItemSelect, selectedKeys }) => {
          if (direction === 'left') {
            const checkedKeys = [...selectedKeys, ...targetKeys];
            return (
              <Styled.TablesTree
                treeData={dataSource}
                checkedKeys={checkedKeys}
                checkable="false"
                onCheck={(_, { node: { key } }) => {
                  onItemSelect(key, !isChecked(checkedKeys, key));
                }}
                virtual="true"
                height={770}
              />
            );
          }
        }
      }
    </Styled.TablesTransfer>
  );
};

OperationsWindow.propTypes = {
  // eslint-disable-next-line
  targetKeys: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  // eslint-disable-next-line
  dataSource: PropTypes.array,
};

OperationsWindow.defaultProps = {
  targetKeys: null,
  dataSource: null,
};

export default OperationsWindow;
